import {
	Box,
	Button,
	Container,
	Grid,
	Paper,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material';
import styles from './main.module.scss';
import { useState } from 'react';
import { versionService } from 'api';
import { ComponentGuard } from 'Auth/ComponentGuard';
import { groups } from 'Auth/authConfig';
import CheckIcon from '@mui/icons-material/Check';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Header } from 'components';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { getCurrentUser } from 'store/selectors/user.selector';

const MainPage = () => {
	const theme = useTheme();
	const currentUser = useSelector(getCurrentUser);
	const [versionInput, setVersionInput] = useState('');
	const [approved, setApproved] = useState(null);
	const [klhAnswer, setKlhAnswer] = useState(null);

	const onChangeInput = (event: any) => {
		// console.log(event.target.value);

		if (klhAnswer) {
			setKlhAnswer(null);
		}
		setVersionInput(event.target.value);
	};

	const onSubmit = () => {
		if (klhAnswer) {
			setKlhAnswer(null);
		}

		versionService
			.sendVersion(versionInput)
			.then((resData: any) => {
				if (resData.error) {
					setKlhAnswer(
						resData.error.error
							? resData.error.error_description
							: resData.error.Message
					);
				} else {
					setApproved(resData.success === versionInput);
					setKlhAnswer('Success');
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};
	return (
		<div className={styles.body}>
			<Header />
			{currentUser ? (
				<ComponentGuard requriedGroups={[groups.groupAdmin]}>
					<div className={styles.container}>
						<Paper elevation={3}>
							<Typography variant="h3" component="h4">
								הכנס מספר גרסה
							</Typography>
							<Grid
								container
								spacing={2}
								style={{
									direction: 'rtl',
									placeContent: 'center',
									width: '100%',
									marginLeft: 0,
								}}
							>
								<Grid item xs={8}>
									<TextField
										id="outlined-basic"
										variant="outlined"
										value={versionInput}
										autoFocus
										onChange={(event: any) => onChangeInput(event)}
									/>
								</Grid>
								<Grid
									item
									xs={4}
									className={styles.approvedPaper}
									style={{ paddingLeft: '0' }}
								>
									<Box
										style={{
											height: '-webkit-fill-available',
											width: '100%',
										}}
									>
										<Button
											variant="outlined"
											onClick={onSubmit}
											style={{
												height: '-webkit-fill-available',
											}}
										>
											שלח לאישור
										</Button>
									</Box>
								</Grid>
								{klhAnswer && (
									<Box
										className={styles.checkBox}
										style={{
											display: 'flex',
											margin: '1vh auto',
											borderRadius: '15px',
										}}
									>
										<Container
											style={{ display: 'flex' }}
											className={approved ? styles.approved : styles.decline}
										>
											<div>{klhAnswer}</div>
											{approved ? <CheckIcon /> : <ClearOutlinedIcon />}
										</Container>
									</Box>
								)}
							</Grid>
						</Paper>
					</div>
				</ComponentGuard>
			) : (
				<Box
					sx={{
						width: 'auto',
						textAlign: '-webkit-center',
						margin: '2vh 0',
					}}
				>
					<Paper>
						<h1>Server Not responding</h1>
					</Paper>
				</Box>
			)}
		</div>
	);
};

export default MainPage;
